import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component, useEffect, useState }  from 'react';
import {Tab, Row, Col, Nav, Accordion, Tabs} from "react-bootstrap";
import {sleep} from "./AddBrandModal";
import {Trash} from "react-feather";
import Moment from "moment";
import { Spinner } from 'reactstrap';
import axios from 'axios';
import { getMarket, apiFetch, API } from "../../services/api";

function UpdateProductLaunchingModal({isOpen, closeModal, selectedProductLaunching, availableMerchands}) {
    const [productLaunching, setProductLaunching] = useState(selectedProductLaunching);
    const [selectedHeadCategory, setSelectedHeadCategory] = useState("/products/shoes");
    const [availableProducts, setAvailableProducts] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedProductDeclinations, setSelectedProductDeclinations] = useState(selectedProductLaunching && selectedProductLaunching.declinations ? selectedProductLaunching.declinations : null);

    const [launchingDate, setLaunchingDate] = useState(selectedProductLaunching && selectedProductLaunching.launchingDate ? selectedProductLaunching.launchingDate : null);

    const [loading, setLoading] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);

    const [loadingSelectedProduct, setLoadingSelectedProduct] = useState(false);
    const [newDeclinaisonMerchandName, setNewDeclinaisonMerchandName] = useState("");
    const [newDeclinaisonMerchandUrl, setNewDeclinaisonMerchandUrl] = useState("");

    const addNewMerchandDeclinaison = (declinaiton, newDeclinaisonMerchandName, declinations) => {
        if (!declinaiton.retailers){
            declinaiton.retailers = []
        }
        declinaiton.retailers.push({
            retailerName: newDeclinaisonMerchandName,
            url: newDeclinaisonMerchandUrl
        })

        var outputDeclinations = []
        if (declinations && declinations.length > 0){
            declinations.map(d => {
                if (d.reference == declinaiton.reference){
                    outputDeclinations.push(declinaiton)
                } else {
                    outputDeclinations.push(d)
                }
            })
        }
        setSelectedProduct({...selectedProduct, declinations: outputDeclinations})
        setSelectedProductDeclinations(outputDeclinations)

        setNewDeclinaisonMerchandName("")
        setNewDeclinaisonMerchandUrl("")
    }

    const removeMerchandDeclinaison = (declinaiton, name, declinations) => {
        let list = declinaiton.retailers.filter((retailer, index) => retailer.retailerName !== name)
        declinaiton.retailers = list

        var outputDeclinations = []
        if (declinations && declinations.length > 0){
            declinations.map(d => {
                if (d.reference == declinaiton.reference){
                    outputDeclinations.push(declinaiton)
                } else {
                    outputDeclinations.push(d)
                }
            })
        }
        setSelectedProduct({...selectedProduct, declinations: outputDeclinations})
        setSelectedProductDeclinations(outputDeclinations)

        setNewDeclinaisonMerchandName("")
        setNewDeclinaisonMerchandUrl("")
    }

    const handleClose = (selectedProduct, selectedProductDeclinations) => {
        setLoadingSubmit(true)
        selectedProduct.launchingDate = launchingDate
        selectedProduct.declinations = selectedProductDeclinations

        console.log(selectedProduct)

        /*if (selectedProduct.declinations && selectedProduct.declinations.length > 0 && selectedProductLaunching && 
            selectedProductLaunching.declinations && selectedProductLaunching.declinations.length > 0){
                var outputDeclinations = []
                var toUpdate = false
                selectedProduct.declinations.map(d => {
                    selectedProductLaunching.declinations.map(existingD => {
                        if ((!d.retailers || d.retailers.length == 0) && (existingD.retailers && existingD.retailers.length > 0)){
                            d.retailers = existingD.retailers
                            toUpdate = true
                        } 
                    })
                    outputDeclinations.push(d)
                })
                if(toUpdate){
                    selectedProduct.declinations = outputDeclinations
                }
        } */

        selectedProduct.language = getMarket()

        apiFetch(API.products + '/product-launching', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(selectedProduct)
        })
        .then(async response =>
            await sleep(2000).then(
                () => (
                    closeModal,
                window.location.reload(false)
            )
            ),
        )
        .catch( err =>
            console.log(err)
        )
        .finally(() =>{
            setLoadingSubmit(false)
        })
    }
        

    const getProducts = (headCategory) => {
        setLoading(true);
    
        axios
        .get('https://back-products-api.therunningcollective.fr/small-products?headCategories='+headCategory+'&lang='+getMarket(), {
            headers: {
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            },
        })
        .then(res => {
            setAvailableProducts(res.data)
        })
        .catch( err =>
            console.log(err)
        )
        .finally(() => {
            setLoading(false)
        })
    }

    const getProduct = (slug) => {
        setLoadingSelectedProduct(true);

        axios
        .get('https://back-products-api.therunningcollective.fr/product?lang='+getMarket()+'&shortURL='+slug, {
            headers: {
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            },
        })
        .then((res) => {
            setSelectedProduct(res.data);
            if(!selectedProductDeclinations || selectedProductDeclinations.length ==0){
                setSelectedProductDeclinations(res.data.declinations)
            }
        })
        .catch( err =>
            console.log(err)
        )
        .finally(() => {
            setLoadingSelectedProduct(false)
        })
    }

    useEffect(() => {
        getProducts(selectedHeadCategory)
    }, [selectedHeadCategory])

    useEffect(() => {
        if(productLaunching && productLaunching !== "" && typeof productLaunching === 'string' && productLaunching !== "[object%20Object]"){
            getProduct(productLaunching)
        }
        if(productLaunching && productLaunching.shortURL && productLaunching.shortURL !== "" && 
            typeof productLaunching.shortURL === 'string' && productLaunching.shortURL !== "[object%20Object]"){
            getProduct(productLaunching.shortURL)
        }
    }, [productLaunching])

    useEffect(() => {
        console.log(productLaunching)
    }, [productLaunching])

    return(
        <Modal
            show={isOpen}
            onHide={closeModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Modifier un lancement de produit</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                    <Row>
                        <Col sm={3}>
                            <Nav variant="pills" className="flex-column">
                                <Nav.Item>
                                    <Nav.Link eventKey="first">Informations générales</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="second">Références </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Col>
                        <Col sm={9}>
                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <Form.Group >
                                        <Form.Label>Catégorie parente : </Form.Label>
                                        <Form.Control
                                            as="select"
                                            custom
                                            onChange={(e) => setSelectedHeadCategory(e.target.value)}
                                            value={selectedHeadCategory}
                                        >
                                            <option value="/products/shoes">Chaussures</option>
                                            <option value="/products/spikes">Pointes</option>
                                            <option value="/products/apparel">Vêtements</option>
                                            <option value="/products/accessories">Accessoires</option>
                                            <option value="/products/electronic">Electronique</option>
                                            <option value="/products/nutrition">Nutrition</option>
                                            <option value="/products/vouchers">Carte cadeau</option>
                                        </Form.Control>
                                    </Form.Group>
                                    {
                                        loading ?
                                        <div style={{textAlign: 'center'}}>
                                            <Spinner animation="border" role="status">
                                                <span className="visually-hidden"></span>
                                            </Spinner>
                                        </div>
                                        : 
                                        <Form.Group>
                                            <Form.Label>Sélection du produit: </Form.Label>
                                            <Form.Control
                                                as="select"
                                                onChange={(e) => setProductLaunching(e.target.value)}
                                                defaultValue={selectedProductLaunching && selectedProductLaunching.shortURL ? selectedProductLaunching.shortURL : ""}
                                            >
                                                {availableProducts && availableProducts.length > 0 && availableProducts.sort((a, b) => a.name > b.name ? 1 : -1).map((product, index) =>
                                                    <option 
                                                        key={product.name}
                                                        value={product.shortURL}
                                                    >
                                                        {product.name}
                                                    </option>
                                                )}
                                            </Form.Control>
                                        </Form.Group>
                                    }
                                    <Form.Group>
                                        <Form.Label>Date de lancement : </Form.Label>
                                        <Form.Control key="launchingDate" type="datetime-local" name="launching" placeholder="Lancement"
                                                        defaultValue={Moment(productLaunching.launchingDate).format('YYYY-MM-DDTHH:mm').toString()}
                                                        onChange={(e) => setLaunchingDate(new Date(e.target.value).toISOString())}
                                        />
                                    </Form.Group>
                                </Tab.Pane>
                                <Tab.Pane eventKey="second">
                                    <Tabs id="uncontrolled-tab-example">
                                        { 
                                            selectedProductLaunching && selectedProductLaunching.declinations && selectedProductLaunching.declinations.length > 0 ?
                                            selectedProductLaunching.declinations.map((declinaiton, index) => (
                                            <Tab key={index} eventKey={index} title={index}>
                                                <Form.Group >
                                                    <Form.Label>Référence : </Form.Label>
                                                    <Form.Control disabled type="text" onChange={(e) => declinaiton.reference = e.target.value} defaultValue={declinaiton.reference} placeholder="123456"/>
                                                </Form.Group>
                                                <Form.Group >
                                                    <Form.Label>Image de couverture : </Form.Label>
                                                    <Form.File
                                                        id="custom-first-img-translate-html"
                                                        label="Ajouter un image"
                                                        data-browse="Ajouter"
                                                        custom
                                                        disabled
                                                    />
                                                    {declinaiton.firstImg ?
                                                            <img className="imgToDisplay" alt="Couverture actuelle" src={declinaiton.firstImg}/>
                                                        :
                                                        null
                                                    }
                                                </Form.Group>
                                                <Form.Group >
                                                    <Form.Label>Vendeurs : </Form.Label>
                                                    <Accordion>
                                                            <Form>
                                                                {declinaiton.retailers && declinaiton.retailers.map(retailer =>(
                                                                    <Form.Group as={Row} key={retailer.retailerName}>
                                                                        <Form.Label column sm="4">
                                                                            <Form.Control
                                                                                as="select"
                                                                                defaultValue={retailer.retailerName}
                                                                                onChange={(e) => retailer.retailerName = e.target.value}
                                                                            >
                                                                                {availableMerchands.map(merchand =>
                                                                                    <option value={merchand.name} key={merchand.name}>{merchand.name}</option>
                                                                                )}
                                                                            </Form.Control>
                                                                        </Form.Label>
                                                                        <Col sm="7" className="retailerUrl">
                                                                            <Form.Control type="text" onChange={(e) => retailer.url = e.target.value} defaultValue={retailer.url} placeholder="https://....."/>
                                                                        </Col>
                                                                        <Col sm="1" className="retailerUrl">
                                                                            <Button variant="secondary" onClick={() => removeMerchandDeclinaison(declinaiton, retailer.retailerName, selectedProduct.declinations)}>
                                                                                <Trash size={10}/>
                                                                            </Button>
                                                                        </Col>

                                                                    </Form.Group>
                                                                ))}
                                                                <Form.Group as={Row}>
                                                                    <Form.Label column sm="4">
                                                                        <Form.Control
                                                                            as="select"
                                                                            defaultValue="Ajouter..."
                                                                            onChange={(e) => setNewDeclinaisonMerchandName(e.target.value)}
                                                                        >
                                                                            <option >Ajouter...</option>
                                                                            {availableMerchands.map(merchand =>
                                                                                <option key={merchand.name} value={merchand.name}>{merchand.name}</option>
                                                                            )}
                                                                        </Form.Control>
                                                                    </Form.Label>
                                                                    <Col sm="7" className="retailerUrl">
                                                                        <Form.Control type="text"  placeholder="https://...."
                                                                                        onChange={(e) => setNewDeclinaisonMerchandUrl(e.target.value)}
                                                                        />
                                                                    </Col>
                                                                    <Col sm="1" className="retailerUrl">
                                                                        <Button variant="secondary" onClick={() => addNewMerchandDeclinaison(declinaiton, newDeclinaisonMerchandName, selectedProduct.declinations)}>+</Button>
                                                                    </Col>
                                                                </Form.Group>
                                                            </Form>
                                                    </Accordion>
                                                </Form.Group>
                                            </Tab>))
                                            : 
                                            selectedProductDeclinations &&  selectedProductDeclinations.length > 0
                                            && selectedProductDeclinations.map((declinaiton, index) => (
                                            <Tab key={index} eventKey={index} title={index}>
                                                <Form.Group >
                                                    <Form.Label>Référence : </Form.Label>
                                                    <Form.Control disabled type="text" onChange={(e) => declinaiton.reference = e.target.value} defaultValue={declinaiton.reference} placeholder="123456"/>
                                                </Form.Group>
                                                <Form.Group >
                                                    <Form.Label>Image de couverture : </Form.Label>
                                                    <Form.File
                                                        id="custom-first-img-translate-html"
                                                        label="Ajouter un image"
                                                        data-browse="Ajouter"
                                                        custom
                                                        disabled
                                                    />
                                                    {declinaiton.firstImg ?
                                                            <img className="imgToDisplay" alt="Couverture actuelle" src={declinaiton.firstImg}/>
                                                        :
                                                        null
                                                    }
                                                </Form.Group>
                                                <Form.Group >
                                                    <Form.Label>Vendeurs : </Form.Label>
                                                    <Accordion>
                                                            <Form>
                                                                {declinaiton.retailers && declinaiton.retailers.map(retailer =>(
                                                                    <Form.Group as={Row} key={retailer.retailerName}>
                                                                        <Form.Label column sm="4">
                                                                            <Form.Control
                                                                                as="select"
                                                                                defaultValue={retailer.retailerName}
                                                                                onChange={(e) => retailer.retailerName = e.target.value}
                                                                            >
                                                                                {availableMerchands.map(merchand =>
                                                                                    <option value={merchand.name} key={merchand.name}>{merchand.name}</option>
                                                                                )}
                                                                            </Form.Control>
                                                                        </Form.Label>
                                                                        <Col sm="7" className="retailerUrl">
                                                                            <Form.Control type="text" onChange={(e) => retailer.url = e.target.value} defaultValue={retailer.url} placeholder="https://....."/>
                                                                        </Col>
                                                                        <Col sm="1" className="retailerUrl">
                                                                            <Button variant="secondary" onClick={() => removeMerchandDeclinaison(declinaiton, retailer.retailerName, selectedProduct.declinations)}>
                                                                                <Trash size={10}/>
                                                                            </Button>
                                                                        </Col>

                                                                    </Form.Group>
                                                                ))}
                                                                <Form.Group as={Row}>
                                                                    <Form.Label column sm="4">
                                                                        <Form.Control
                                                                            as="select"
                                                                            defaultValue="Ajouter..."
                                                                            onChange={(e) => setNewDeclinaisonMerchandName(e.target.value)}
                                                                        >
                                                                            <option >Ajouter...</option>
                                                                            {availableMerchands.map(merchand =>
                                                                                <option key={merchand.name} value={merchand.name}>{merchand.name}</option>
                                                                            )}
                                                                        </Form.Control>
                                                                    </Form.Label>
                                                                    <Col sm="7" className="retailerUrl">
                                                                        <Form.Control type="text"  placeholder="https://...."
                                                                                        onChange={(e) => setNewDeclinaisonMerchandUrl(e.target.value)}
                                                                        />
                                                                    </Col>
                                                                    <Col sm="1" className="retailerUrl">
                                                                        <Button variant="secondary" onClick={() => addNewMerchandDeclinaison(declinaiton, newDeclinaisonMerchandName, selectedProduct.declinations)}>+</Button>
                                                                    </Col>
                                                                </Form.Group>
                                                            </Form>
                                                    </Accordion>
                                                </Form.Group>
                                            </Tab>
                                        ))
                                        }
                                    </Tabs>
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </Modal.Body>
            <Modal.Footer>
                {
                    loadingSubmit ?
                        <div style={{textAlign: 'center'}}>
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden"></span>
                            </Spinner>
                        </div>
                    : 
                    <>
                        <Button variant="secondary" type="cancel" onClick={() => closeModal()}>
                            Annuler
                        </Button>
                        <Button variant="primary" type="submit" onClick={() => handleClose(selectedProduct, selectedProductDeclinations)}>
                            Valider
                        </Button>
                    </>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default UpdateProductLaunchingModal;

function getSelectedItems(items){
    var arrayToReturn = []

    if (items) {
        items.map(item => (
            arrayToReturn.push(item.name)
        ))
    }

    return arrayToReturn
}